import styled from 'styled-components'
import { media } from '../../../utils'

export const LandSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.large};
  width: 100%;
  padding: 0px ${({ theme }) => theme.spacing.large};

  ${media.mobileOnly} {
    gap: ${({ theme }) => theme.spacing.medium};
    padding: 0px ${({ theme }) => theme.spacing.small};
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.huge};
  text-align: center;

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.large};
  }

  p {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: ${({ theme }) => theme.typography.fontSize.body};
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.huge};
  text-align: center;
  color: ${({ theme }) => theme.colors.danger};

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.large};
  }
`

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};

  h3 {
    font-size: ${({ theme }) => theme.typography.fontSize.section};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
  }

  p {
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0;
  }
`

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.huge};
  text-align: center;
  color: ${({ theme }) => theme.colors.text.tertiary};

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.large};
  }
`

export const EmptyMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};

  h3 {
    font-size: ${({ theme }) => theme.typography.fontSize.section};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
  }

  p {
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0;
  }
`

export const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.large};

  ${media.mobileOnly} {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`
